import React from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import GooglePlayImage from './../../../assets/img/app/googleplay.png'
import AppStoreImage from './../../../assets/img/app/appstore.svg'

import SmartphoneImage from './../../../assets/img/app/smartphone.png'

import './index.css'

export default function DownloadApp(){

    return (
        <section className="DownloadApp section-padding blue-background white-text">
            <Container>
                <Row>
                    <Col md={6}>
                        <h1 className="section-title">Baixe o aplicativo</h1>
                        <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                        It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. 
                        </p>

                        <Row>
                            <Col md={6}>
                                <a href="/#download" target="_blank">
                                    <img src={GooglePlayImage} className="img-fluid"  alt="download on google play" width="250" style={{ transform: 'translate(-15px, 0px)' }}/>
                                </a>

                                <a href="/#download" target="_blank">
                                    <img src={AppStoreImage} className="img-fluid"  alt="download on app store" width="220" />
                                </a>
                            </Col>
                            <Col md={6}>
                              
                            </Col>    
                        </Row>

                    </Col>

                    <Col md={6}>
                        <img className="img-fluid" src={SmartphoneImage} alt="smartphone" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}